export default __webpack_public_path__ + "static/media/Acropolis_LE.56410017.jpg";